module.exports = __webpack_public_path__ + "img/dhl-logo.f90802e6.svg";